import axios from "axios";
import {
  LocationAddressType,
  WandaTripStatus,
} from "../types/ApplicationTypes";
import * as AppSettingsService from "./AppSettingsService";
import {
  IServiceUserInfo,
  IServiceUserTripInfoWithDuplicateDates,
} from "../types/ServiceUserInfo";
import moment from "moment";
import { WandaOrganizationDetails } from "../types/OrganizationTypes";
import {
  ITripEditFavorite,
  ITripPaginationData,
  ITripStatusChangeData,
  WheelchairUpdate,
} from "../types/TripTypes";
import { notification } from "antd";
import { ITripDetails } from "../components/ServiceUsers/Interfaces/ITripDetails";
import { CustomerCareDetails } from "../types/PersonTypes";
const appSettings = AppSettingsService;

export async function checkIsRegisteredEmail(data: any): Promise<any> {
  try {
    const response = await axios.post(
      `${appSettings.getAppApiUrl()}/ccp/Registration/v1/GetUserByEmail`,
      data
    );
    return response.data;
  } catch (error) {
    console.log(error);
    throw error;
  }
}

export async function GetPersonRegistrationMatch(data: any): Promise<any> {
  try {
    const response = await axios.post(
      `${appSettings.getAppApiUrl()}/ccp/Registration/v1/PersonRegMatch`,
      data
    );
    return response.data;
  } catch (error) {
    console.log(error);
    throw error;
  }
}

export async function getGeocode(data: any): Promise<any> {
  try {
    const response = await axios.post(
      `${appSettings.getAppApiUrl()}/ccp/Map/v1/Geocode`,
      data
    );
    return response.data;
  } catch (error: any) {
    if (error.response.status === 409) {
      notification.error({
        message: "error",
        description:
          "If zip code cannot be verified, please update your browser settings to Allow all cookies.",
      });
      throw error;
    } else {
      console.log(error);
      throw error;
    }
  }
}

export async function ZipCodeSearchUpsert(data: any): Promise<any> {
  try {
    const response = await axios.post(
      `${appSettings.getAppApiUrl()}/ccp/Registration/v1/ZipCodeSearchUpsert`,
      data
    );
    return response.data;
  } catch (error) {
    console.log(error);
    throw error;
  }
}

export async function UserRegistration(data: any): Promise<any> {
  try {
    const response = await axios.post(
      `${appSettings.getAppApiUrl()}/ccp/Registration/v1/UserRegistration`,
      data
    );
    return response.data;
  } catch (error) {
    console.log(error);
    throw error;
  }
}

export async function UpdateCCPRegistrationDetails(data: any): Promise<any> {
  try {
    const response = await axios.post(
      `${appSettings.getAppApiUrl()}/ccp/Registration/v1/UpdateCCPRegistrationDetails`,
      data
    );
    return response;
  } catch (error) {
    console.log(error);
    throw error;
  }
}

export async function GetRegistrationStatusDetails(
  email: any,
  PersonId: number,
  SearchParameter: any,
  recaptchaToken: string
): Promise<any> {
  try {
    const response = await axios.get(
      `${appSettings.getAppApiUrl()}/ccp/Registration/v1/GetRegistrationStatusDetails?Email=${email}&PersonId=${PersonId}&SearchParameter=${SearchParameter}&RecaptchaToken=${recaptchaToken}`
    );
    return response;
  } catch (error) {
    console.log(error);
    throw error;
  }
}

export async function uploadCCPDetailsImage(file: File, personId: number): Promise<any> {
  const fileBase64 = await convertFileToBase64(file);
  const config = {
    contentType: file.type,
    fileData: fileBase64,
    filename: file.name,
    folder: "ccp",
  };
  try {
    const response = await axios.post(
      `${appSettings.getAppApiUrl()}/personorg/file/v1/upload`,
      config,
      { headers: { "x-personId": personId } }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
}

function convertFileToBase64(file: File) {
  return new Promise((resolve, reject) => {
    var reader = new FileReader();
    reader.onload = () => {
      resolve(reader.result);
    };
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });
}

export async function updateAdditionalDetailsForPerson(
  data: any
): Promise<any> {
  try {
    const response = await axios.post(
      `${appSettings.getAppApiUrl()}/ccp/Registration/v1/createperson`,
      data,
      { headers: { "x-personId": data.personId } }
    );
    return response.data;
  } catch (error) {
    console.log(error);
    throw error;
  }
}

export async function getAutoComplete(input: string): Promise<any> {
  try {
    const response = await axios.get(
      `${appSettings.getAppApiUrl()}/common/map/v1/autoComplete`,
      {
        params: {
          input: input,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
}

export async function getPlaceDetails(placeId: string, description?: string): Promise<any> {
  try {
    const response = await axios.get(
      `${appSettings.getAppApiUrl()}/common/map/v1/placesDetails`,
      {
        params: {
          Place_Id: placeId,
          description
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
}

export async function AddCCPRoleToUser(data: any): Promise<any> {
  try {
    const response = await axios.post(
      `${appSettings.getAppApiUrl()}/ccp/Registration/v1/AddCCPRoleToUser`,
      data,
      { headers: { "x-personId": data.personId } }
    );
    return response;
  } catch (error) {
    console.log(error);
    throw error;
  }
}

export async function upsertPersonPersonRel(data: any): Promise<any> {
  try {
    const response = await axios.post(
      `${appSettings.getAppApiUrl()}/personorg/personadmin/v1/upsertpersonpersonrel`,
      data,
      { headers: { "x-personId": data.personId } }
    );
    return response;
  } catch (error) {
    console.log(error);
    throw error;
  }
}

export async function validateAddressUSPS(location: LocationAddressType) {
  try {
    const response = await axios.post(
      `${appSettings.getAppApiUrl()}/common/map/v1/uspsAddress`,
      location
    );
    return response.data;
  } catch (error) {
    throw error;
  }
}

export async function getLookupListByListName(
  version: number,
  listName: string
): Promise<any> {
  try {
    const config = { params: { name: listName } };
    const response = await axios.get(
      `${appSettings.getAppApiUrl()}/personorg/lookup/v${version}/list/items`,
      config
    );
    return response.data;
  } catch (error) {
    throw error;
  }
}

export async function getPersonType(personId: number): Promise<any> {
  try {
    const config = {
      params: {
        personId: personId,
      },
    };
    const response = await axios.get(
      `${appSettings.getAppApiUrl()}/personorg/personAdmin/v1/personType`,
      config
    );
    return response.data;
  } catch (error) {
    throw error;
  }
}

export async function getPersonAttributeKey(data: any): Promise<any> {
  try {
    const response = await axios.post(
      `${appSettings.getAppApiUrl()}/ccp/Registration/v1/personattributekey`,
      data
    );
    return response.data;
  } catch (error) {
    throw error;
  }
}

export async function resetUserPassword(data: any): Promise<any> {
  try {
    const response = await axios.post(
      `${appSettings.getAppApiUrl()}/ccp/Registration/v1/ResetPassword`,
      data
    );
    return response.data;
  } catch (error) {
    throw error;
  }
}

export async function GetPersonPersonRelationships(
  organizationId: number,
  personId: number,
  position: number
): Promise<any> {
  try {
    const response = await axios.get(
      `${appSettings.getAppApiUrl()}/personorg/personadmin/v1/personpersonrelationships?OrganizationId=${organizationId}&PersonId=${personId}&Position=${position}`,
      { headers: { "x-personId": personId } }
    );
    return response;
  } catch (error) {
    console.log(error);
    throw error;
  }
}

export async function downloadContentImage(key: string): Promise<any> {
  const config = {
    folder: "ccp",
    key: key,
  };
  try {
    const response = await axios.post(
      `${appSettings.getAppApiUrl()}/personorg/file/v1/download`,
      config
    );
    return response.data;
  } catch (error) {
    console.log(error);
    throw error;
  }
}

export async function UpsertTrustedContactDetails(data: any): Promise<any> {
  try {
    const response = await axios.post(
      `${appSettings.getAppApiUrl()}/ccp/Registration/v1/UpsertTrustedContact`,
      data
    );
    return response;
  } catch (error) {
    console.log(error);
    throw error;
  }
}

export async function UpsertWandaSubscriptionPlan(data: any): Promise<any> {
  try {
    const response = await axios.post(
      `${appSettings.getAppApiUrl()}/ccp/Registration/v1/UpsertWandaSubscriptionPlan`,
      data
    );
    return response;
  } catch (error) {
    console.log(error);
    throw error;
  }
}

export async function tripStatusChange(
  data: ITripStatusChangeData,
  personId: number
): Promise<any> {
  try {
    const response = await axios.post(
      `${appSettings.getAppApiUrl()}/ccp/Trip/v1/ChangeStatus`,
      data,
      { headers: { "x-personId": personId } }
    );
    return response.status;
  } catch (error) {
    throw error;
  }
}

export async function getTripByRequestAssignmentId(params: {
  requestAssignmentId: number;
  personId: number;
  favoriteId: number;
  tripDate: string;
}): Promise<any> {
  try {
    const baseUrl = `${appSettings.getAppApiUrl()}/ccp/Trip/v1/GetTripByRequestAssignmentId`;

    const response = await axios.get(baseUrl, { params });

    return response.data;
  } catch (error) {
    throw error;
  }
}

export async function getServiceUsersInfo(personId: number): Promise<any> {
  try {
    const response = await axios.get(
      `${appSettings.getAppApiUrl()}/ccp/Profiling/v1/GetServiceuserInfo?PersonId=${personId}`,
      { headers: { "x-personId": personId } }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
}

export async function getServiceusersInfoByServiceTakerId(
  careGiverId: number,
  serviceTakerId: number
): Promise<IServiceUserInfo> {
  try {
    const response = await axios.get(
      `${appSettings.getAppApiUrl()}/ccp/Profiling/v1/GetServiceuserInfo?PersonId=${careGiverId}`,
      { headers: { "x-personId": careGiverId } }
    );
    const result =
      response.data.length &&
      response.data.find(
        (item: IServiceUserInfo) => item.personId === serviceTakerId
      );
    return result;
  } catch (error) {
    throw error;
  }
}

export async function getTrustedContactsByPersonId(
  PersonId: number
): Promise<any> {
  try {
    const response = await axios.get(
      `${appSettings.getAppApiUrl()}/ccp/Registration/v1/TrustedContactList?personId=${PersonId}`
    );
    return response.data;
  } catch (error) {
    console.log(error);
    throw error;
  }
}

export async function getPersonUserAccountInfo(personId: number): Promise<any> {
  try {
    const response = await axios.get(
      `${appSettings.getAppApiUrl()}/ccp/Profiling/v1/GetWandaUserInfo?PersonId=${personId}`,
      { headers: { "x-personId": personId } }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
}

export async function getServiceUserInfoForDashBoard(
  personId: number,
  fromDate: string,
  toDate: string,
): Promise<any> {
  try {
    let wandaStatusid =
      WandaTripStatus.Booked + "," + WandaTripStatus.Completed;
    const response = await axios.get(
      `${appSettings.getAppApiUrl()}/ccp/Trip/v1/GetWandaTripWithPagination?personId=${personId}&fetchRows=30&wandaTripStatusIds=${wandaStatusid}&fromDate=${fromDate}&toDate=${toDate}`,
      
    );
    return response.data?.personTrips;
  } catch (error) {
    throw error;
  }
}

export async function getWandaTripWithPagination(
  options: ITripPaginationData
): Promise<any> {
  try {
    const baseUrl = `${appSettings.getAppApiUrl()}/ccp/Trip/v1/GetWandaTripWithPagination`;

    const params = Object.fromEntries(
      Object.entries(options).filter(
        ([_, value]) => ![undefined, ""].includes(value)
      )
    );

    const response = await axios.get(baseUrl, { params });
    return response.data;
  } catch (error) {
    throw error;
  }
}

export async function getFavoriteTripWithPagination(
  personId: number,
  rowsToSkip: number,
  fetchRows: number,
  fromDate: string,
  toDate: string,
  selectedPersonId: string,
  sortOrder: string
): Promise<any> {
  try {
    const response = await axios.get(
      `${appSettings.getAppApiUrl()}/ccp/Trip/v1/GetFavoriteTripWithPagination?personId=${personId}&rowsToSkip=${rowsToSkip}&fetchRows=${fetchRows}&fromDate=${fromDate}&toDate=${toDate}&selectedPersonId=${selectedPersonId}&sortOrder=${sortOrder}`
    );
    return response.data;
  } catch (error) {
    throw error;
  }
}

export async function deleteFavoriteTrip(
  data: ITripEditFavorite
): Promise<any> {
  try {
    const response = await axios.post(
      `${appSettings.getAppApiUrl()}/ccp/Trip/v1/DeleteFavorite`,
      data
    );
    return response.data;
  } catch (error) {
    throw error;
  }
}

export async function updateFavoriteTrip(
  data: ITripEditFavorite
): Promise<any> {
  try {
    const response = await axios.post(
      `${appSettings.getAppApiUrl()}/ccp/Trip/v1/UpdateFavorite`,
      data,
      { headers: { "x-personId": data.personId } }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
}

export async function getServiceUserInfoForDashBoardByPersonId(
  careGiverId: number,
  serviceUserId: number
): Promise<IServiceUserTripInfoWithDuplicateDates> {
  try {
    let wandaStatusid =
      WandaTripStatus.Booked + "," + WandaTripStatus.Completed;
    const response = await axios.get(
      `${appSettings.getAppApiUrl()}/ccp/Trip/v1/GetWandaTripWithPagination?personId=${careGiverId}&skipPagination=true&wandaTripStatusIds=${wandaStatusid}`
    );
    const filteredTrips =
      response.data?.personTrips.length > 0 &&
      response.data?.personTrips.filter(
        (item: ITripDetails) => item.personId === serviceUserId
      );
    const duplicateDates: string[] = [];
    if (filteredTrips) {
      filteredTrips.map((item: ITripDetails) => {
        const tripDate = item.isWillCall
          ? item.tripDate.split("T")[0]
          : item.appointmentTime === null
          ? item.requestPickTime.split("T")[0]
          : item.appointmentTime.split("T")[0];
        duplicateDates.push(moment(tripDate).format("MM/DD/YYYY"));
      });
    }
    const result: IServiceUserTripInfoWithDuplicateDates = {
      serviceUserTripInfo: filteredTrips || [],
      duplicateDates: duplicateDates,
    };
    return result;
  } catch (error) {
    throw error;
  }
}

export async function getWandaOrganizationByName(
  organizationName: string,
  personId: number,
  recaptchaToken: string
): Promise<WandaOrganizationDetails> {
  try {
    const response = await axios.get(
      `${appSettings.getAppApiUrl()}/ccp/registration/v1/WandaOrganizationbyname?organizationName=${organizationName}&personId=${personId}&recaptchaToken=${recaptchaToken}`
    );
    return response.data;
  } catch (error) {
    throw error;
  }
}

export async function UpdatePersonAttributesKey(
  data: WheelchairUpdate
): Promise<{status: number}> {
  try {
    const response = await axios.post(
      `${appSettings.getAppApiUrl()}/ccp/Registration/v1/UpdatePersonAttributesKey`,
      data
    );
    return {
      status: response.status,
    };
  } catch (error) {
    throw error;
  }
}

export async function getWandaCustomerCareDetails(
  recaptchaToken: string,
): Promise<CustomerCareDetails> {
  try {
    const response = await axios.get(
      `${appSettings.getAppApiUrl()}/ccp/Registration/v1/GetWandaCustomerCareDetails?recaptchaToken=${recaptchaToken}`
    );
    return response.data;
  } catch (error) {
    throw error;
  }
}

export async function createPromoCodeCustomer(
  personId: number,
  userType: string
) {
  try {
    const customerInfo = {
      personId: personId,
      userType: userType
    }
    await axios.post(
      `${appSettings.getAppApiUrl()}/common/PromoCode/v1/PromoCode/Customer`,
      customerInfo
    );
  } catch (error) {
    throw error;
  }
}

